import React, { useMemo } from "react"

import { useTranslation } from "react-i18next"
import { useQuery } from "react-query"
import { useSelector } from "react-redux"

import { Grid } from "@mui/material"
import type { AxiosError } from "axios"
import type { MRT_ColumnDef } from "material-react-table"

import { KonanPageHeader } from "../../components/core/KonanPageHeader"
import { BaseTable } from "../../components/tables/BaseTable"
import { KonanAPI } from "../../services/KonanAPI"
import type { RootState } from "../../store/ReduxStore"
import type { KonanRegistryImagesSeriliazer } from "../../types/generated/api/KonanRegistryImagesSeriliazer"
import { RegistryCredentials } from "./components/RegistryCredentials"

type ModifiedImagesList = {
  id: number
  image_url: string
}

export function Registry(): React.ReactElement {
  const orgId = useSelector((state: RootState) => state.auth.organizationId) as string

  const { t } = useTranslation("registry")

  const { isLoading, data } = useQuery<Array<KonanRegistryImagesSeriliazer>, AxiosError>(
    ["registry-images", orgId],
    () => KonanAPI.fetchRegistryImages(),
  )

  const modifiedData = useMemo(() => {
    const images: ModifiedImagesList[] = []
    data?.forEach((item, index) =>
      images.push({
        id: index + 1,
        image_url: item.image,
      }),
    )
    return images
  }, [data])

  const columns: MRT_ColumnDef<ModifiedImagesList>[] = [
    {
      header: "#",
      accessorKey: "id",
      enableResizing: true,
      maxSize: 10,
      size: 5,
      minSize: 0,
      enableColumnFilter: false,
    },
    {
      header: t("table.headers.containerImageUrl.title"),
      accessorKey: "image_url",
      enableResizing: true,
    },
  ]

  return (
    <div className="layoutPadding">
      <KonanPageHeader title={t("title")} subtitle={t("subtitle")} />
      <Grid container spacing={2} paddingTop={2}>
        <Grid item xs={12}>
          <BaseTable
            enableOrdering={false}
            disableToolbarActions={true}
            columns={columns as MRT_ColumnDef[]}
            data={modifiedData}
            isLoading={isLoading}
            enableHiding={false}
            title={t("table.title")}
          />
        </Grid>

        <Grid item xs={12}>
          <RegistryCredentials />
        </Grid>
      </Grid>
    </div>
  )
}
